export const SUCCESS_GET_NUM_BOOKINGS = 'SUCCESS_GET_NUM_BOOKINGS';
export const FAILED_GET_NUM_BOOKINGS = 'FAILED_GET_NUM_BOOKINGS';
export const SUCCESS_GET_NUM_BOOKINGS_PER_STATUS = 'SUCCESS_GET_NUM_BOOKINGS_PER_STATUS';
export const FAILED_GET_NUM_BOOKINGS_PER_STATUS = 'FAILED_GET_NUM_BOOKINGS_PER_STATUS';
export const SUCCESS_GET_NUM_ACTIVE_BOOKINGS_PER_CLIENT = 'SUCCESS_GET_NUM_ACTIVE_BOOKINGS_PER_CLIENT';
export const FAILED_GET_NUM_ACTIVE_BOOKINGS_PER_CLIENT = 'SUCCESS_GET_NUM_ACTIVE_BOOKINGS_PER_CLIENT';



// WEBPACK FOOTER //
// src/state/constants/chartConstants.js